import React from 'react';

interface SchoolCapIconProps {
  fill?: string;
  className?: string;
}

export const SchoolCapIcon: React.FC<SchoolCapIconProps> = ({ fill = '#BCD7CF', className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="117"
    height="72"
    viewBox="0 0 117 72"
    fill="none"
    className={className}
  >
    <path
      d="M58.9551 0.523438C58.4348 0.349772 57.8697 0.329025 57.3359 0.458984L57.1094 0.523438L57.1074 0.524414L2.11035 18.9551L2.11133 18.959C1.08992 19.303 0.374023 20.1941 0.374023 21.2295C0.374077 22.1983 1.00602 23.0483 1.93066 23.4326L2.11914 23.5029L14.126 27.5244V52.1143C13.0427 52.2547 12.1183 52.9927 11.8877 54.0273L9.59668 64.2637C9.43282 64.9906 9.64622 65.7365 10.1592 66.2969C10.6698 66.8545 11.4205 67.1699 12.2051 67.1699H21.3701C22.1495 67.1699 22.9051 66.8548 23.416 66.2969V66.2959C23.9297 65.7387 24.142 64.9889 23.9785 64.2637L21.6875 54.0273L21.6299 53.8154C21.3278 52.8924 20.4571 52.2449 19.4492 52.1143V29.3125L27.8633 32.1328V60.1377C27.8633 60.997 28.3621 61.7717 29.1387 62.2061H29.1396C39.4693 67.9468 48.9237 70.7499 58.0283 70.75C67.1332 70.75 76.5829 67.9468 86.918 62.2061H86.9189C87.6955 61.7718 88.1934 60.997 88.1934 60.1377V32.1328L113.949 23.502V23.501C114.974 23.1587 115.693 22.2663 115.693 21.2285C115.693 20.1954 114.975 19.2974 113.949 18.9551L58.9561 0.524414L58.9551 0.523438ZM57.1182 41.9277C57.4144 42.0276 57.7299 42.0781 58.0391 42.0781C58.3497 42.0781 58.6609 42.0277 58.96 41.9287H58.9609L82.8682 33.917V58.7598C73.8681 63.5749 65.7359 65.9014 58.0352 65.9014C50.3319 65.9014 42.2031 63.5755 33.2109 58.7637V33.917L57.1182 41.9277ZM18.8037 62.3252H14.7949L16 56.9326H17.5996L18.8037 62.3252ZM105.332 21.2236L58.04 37.0703L23.8291 25.6055L42.9004 19.4092C44.2643 18.9632 45.0237 17.5787 44.5 16.2852L44.499 16.2832C43.9793 15.0197 42.4422 14.4103 41.0977 14.8467L16.0273 22.9932L10.748 21.2236L58.04 5.37695L105.332 21.2236Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.75"
    />
  </svg>
);
